<template>
  <div>
    <b-row align-v="center" class="justify-content-start mb-1" no-gutters>
      <b-col cols="2">
        <b-input-group size="sm">
          <b-input placeholder="전화번호 뒷 4자리 또는 예약번호" @keypress.native.enter="onClickSearch" v-model="searchKeyword"/>
        </b-input-group>
      </b-col>
      <b-col>
        <b-button class="btn-sm ml-2" variant="outline-primary" @click="onClickSearch">예약 조회</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    mounted() {
    },
    data() {
      return {
        searchKeyword: "",
        isMobileSearch: false,
      }
    },
    methods: {
      doNothing() {
      },
      onClickSearch() {
        this.$emit('search-booking', this.searchKeyword)
      }
    },
    watch: {
      isMobileSearch(val) {
        if (val) {
          document.addEventListener("click", this.handleDocumentforMobileSearch);
        } else {
          document.removeEventListener(
            "click",
            this.handleDocumentforMobileSearch
          );
        }
      }
    }
  }
</script>
